<template>
  <el-form-item
    :label="label"
    class="airport-name"
    :prop="prop"
    :rules="rules"
  >
    <el-autocomplete
      v-model="airportName"
      :clearable="true"
      :maxlength="60"
      :placeholder="placeholder"
      :disabled="disabled"
      :fetch-suggestions="querySearch"
      :trigger-on-focus="false"
      :autofocus="autofocus"
    />
  </el-form-item>
</template>

<script>
import AutocompleteFilter from '@/mixins/AutocompleteFilter.vue'
import Validator from '@/mixins/Validator.vue'

export default {
  components: {
  },
  mixins: [
    AutocompleteFilter,
    Validator
  ],
  props: {
    value: String,
    label: {
      type: String,
      default: '空港名'
    },
    prop: {
      type: String,
      default: 'airport_name'
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    searchCond: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      placeholder: this.searchCond ? '前方一致' : '最大60文字'
    }
  },
  computed: {
    airportName: {
      get () {
        return this.value
      },
      set (airportName) {
        this.$emit('input', airportName)
      }
    },
    rules: {
      get () {
        const rules = []
        if (!this.disabled) {
          if (this.required) {
            rules.push(this.validatorRequired(this.label, 'blur'))
          }
        }
        return rules
      }
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.airport-name {
  ::v-deep .el-form-item__content {
    width: 18em;
  }
}
</style>
